module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icon_arrow_red_circle_next-bb170d290a4d538f8fecc51d0bc6d9ac.svg";